import { SelectableItem } from '../types/search-select.types';

export const STATES_BY_COUNTRY: Record<string, SelectableItem[]> = {
	US: [
		{ value: 'US-AK', displayText: 'Alaska' },
		{ value: 'US-AL', displayText: 'Alabama' },
		{ value: 'US-AR', displayText: 'Arkansas' },
		{ value: 'US-AZ', displayText: 'Arizona' },
		{ value: 'US-CA', displayText: 'California' },
		{ value: 'US-CO', displayText: 'Colorado' },
		{ value: 'US-CT', displayText: 'Connecticut' },
		{ value: 'US-DC', displayText: 'Dist of Columbia' },
		{ value: 'US-DE', displayText: 'Delaware' },
		{ value: 'US-FL', displayText: 'Florida' },
		{ value: 'US-GA', displayText: 'Georgia' },
		{ value: 'US-HI', displayText: 'Hawaii' },
		{ value: 'US-IA', displayText: 'Iowa' },
		{ value: 'US-ID', displayText: 'Idaho' },
		{ value: 'US-IL', displayText: 'Illinois' },
		{ value: 'US-IN', displayText: 'Indiana' },
		{ value: 'US-KS', displayText: 'Kansas' },
		{ value: 'US-KY', displayText: 'Kentucky' },
		{ value: 'US-LA', displayText: 'Louisiana' },
		{ value: 'US-MA', displayText: 'Massachusetts' },
		{ value: 'US-MD', displayText: 'Maryland' },
		{ value: 'US-ME', displayText: 'Maine' },
		{ value: 'US-MI', displayText: 'Michigan' },
		{ value: 'US-MN', displayText: 'Minnesota' },
		{ value: 'US-MO', displayText: 'Missouri' },
		{ value: 'US-MS', displayText: 'Mississippi' },
		{ value: 'US-MT', displayText: 'Montana' },
		{ value: 'US-NC', displayText: 'North Carolina' },
		{ value: 'US-ND', displayText: 'North Dakota' },
		{ value: 'US-NE', displayText: 'Nebraska' },
		{ value: 'US-NH', displayText: 'New Hampshire' },
		{ value: 'US-NJ', displayText: 'New Jersey' },
		{ value: 'US-NM', displayText: 'New Mexico' },
		{ value: 'US-NV', displayText: 'Nevada' },
		{ value: 'US-NY', displayText: 'New York' },
		{ value: 'US-OH', displayText: 'Ohio' },
		{ value: 'US-OK', displayText: 'Oklahoma' },
		{ value: 'US-OR', displayText: 'Oregon' },
		{ value: 'US-PA', displayText: 'Pennsylvania' },
		{ value: 'US-PR', displayText: 'Puerto Rico' },
		{ value: 'US-RI', displayText: 'Rhode Island' },
		{ value: 'US-SC', displayText: 'South Carolina' },
		{ value: 'US-SD', displayText: 'South Dakota' },
		{ value: 'US-TN', displayText: 'Tennessee' },
		{ value: 'US-TX', displayText: 'Texas' },
		{ value: 'US-UT', displayText: 'Utah' },
		{ value: 'US-VA', displayText: 'Virginia' },
		{ value: 'US-VT', displayText: 'Vermont' },
		{ value: 'US-WA', displayText: 'Washington' },
		{ value: 'US-WI', displayText: 'Wisconsin' },
		{ value: 'US-WV', displayText: 'West Virginia' },
		{ value: 'US-WY', displayText: 'Wyoming' },
	],
	UK: [
		{ value: 'GB-AVN', displayText: 'Avon' },
		{ value: 'GB-BDF', displayText: 'Bedfordshire' },
		{ value: 'GB-BRK', displayText: 'Berkshire' },
		{ value: 'GB-SCB', displayText: 'Borders' },
		{ value: 'GB-BKM', displayText: 'Buckinghamshire' },
		{ value: 'GB-CAM', displayText: 'Cambridgeshire' },
		{ value: 'GB-CEN', displayText: 'Central' },
		{ value: 'GB-CHS', displayText: 'Cheshire' },
		{ value: 'GB-CLV', displayText: 'Cleveland' },
		{ value: 'GB-CWD', displayText: 'Clwyd' },
		{ value: 'GB-CON', displayText: 'Cornwall' },
		{ value: 'GB-ANT', displayText: 'County Antrim' },
		{ value: 'GB-ARM', displayText: 'County Armagh' },
		{ value: 'GB-DOW', displayText: 'County Down' },
		{ value: 'GB-FER', displayText: 'County Fermanagh' },
		{ value: 'GB-LDY', displayText: 'County Londonderry' },
		{ value: 'GB-TYR', displayText: 'County Tyrone' },
		{ value: 'GB-CMA', displayText: 'Cumbria' },
		{ value: 'GB-DBY', displayText: 'Derbyshire' },
		{ value: 'GB-DEV', displayText: 'Devon' },
		{ value: 'GB-DOR', displayText: 'Dorset' },
		{ value: 'GB-DGY', displayText: 'Dumfries and Galloway' },
		{ value: 'GB-DUR', displayText: 'Durham' },
		{ value: 'GB-DFD', displayText: 'Dyfed' },
		{ value: 'GB-ESX', displayText: 'East Sussex' },
		{ value: 'GB-ESS', displayText: 'Essex' },
		{ value: 'GB-FIF', displayText: 'Fife' },
		{ value: 'GB-GLS', displayText: 'Gloucestershire' },
		{ value: 'GB-GMP', displayText: 'Grampian' },
		{ value: 'GB-GTM', displayText: 'Greater Manchester' },
		{ value: 'GB-GNT', displayText: 'Gwent' },
		{ value: 'GB-GWN', displayText: 'Gwynedd County' },
		{ value: 'GB-HAM', displayText: 'Hampshire' },
		{ value: 'GB-HEF', displayText: 'Herefordshire' },
		{ value: 'GB-HRT', displayText: 'Hertfordshire' },
		{ value: 'GB-HLD', displayText: 'Highlands and Islands' },
		{ value: 'GB-HUM', displayText: 'Humberside' },
		{ value: 'GB-IOW', displayText: 'Isle of Wight' },
		{ value: 'GB-KEN', displayText: 'Kent' },
		{ value: 'GB-LAN', displayText: 'Lancashire' },
		{ value: 'GB-LEI', displayText: 'Leicestershire' },
		{ value: 'GB-LIN', displayText: 'Lincolnshire' },
		{ value: 'GB-LTN', displayText: 'Lothian' },
		{ value: 'GB-MSY', displayText: 'Merseyside' },
		{ value: 'GB-MGM', displayText: 'Mid Glamorgan' },
		{ value: 'GB-NFK', displayText: 'Norfolk' },
		{ value: 'GB-NYK', displayText: 'North Yorkshire' },
		{ value: 'GB-NTH', displayText: 'Northamptonshire' },
		{ value: 'GB-NBL', displayText: 'Northumberland' },
		{ value: 'GB-NTT', displayText: 'Nottinghamshire' },
		{ value: 'GB-OXF', displayText: 'Oxfordshire' },
		{ value: 'GB-POW', displayText: 'Powys' },
		{ value: 'GB-RUT', displayText: 'Rutland' },
		{ value: 'GB-SAL', displayText: 'Shropshire' },
		{ value: 'GB-SOM', displayText: 'Somerset' },
		{ value: 'GB-SGM', displayText: 'South Glamorgan' },
		{ value: 'GB-SYK', displayText: 'South Yorkshire' },
		{ value: 'GB-STS', displayText: 'Staffordshire' },
		{ value: 'GB-STD', displayText: 'Strathclyde' },
		{ value: 'GB-SFK', displayText: 'Suffolk' },
		{ value: 'GB-SRY', displayText: 'Surrey' },
		{ value: 'GB-TAY', displayText: 'Tayside' },
		{ value: 'GB-TWR', displayText: 'Tyne and Wear' },
		{ value: 'GB-WAR', displayText: 'Warwickshire' },
		{ value: 'GB-WGM', displayText: 'West Glamorgan' },
		{ value: 'GB-WMD', displayText: 'West Midlands' },
		{ value: 'GB-WSX', displayText: 'West Sussex' },
		{ value: 'GB-WYK', displayText: 'West Yorkshire' },
		{ value: 'GB-WIL', displayText: 'Wiltshire' },
		{ value: 'GB-WOR', displayText: 'Worcestershire' },
	],
	AR: [
		{ value: 'AR-C', displayText: 'Ciudad Autónoma de Buenos Aires' },
		{ value: 'AR-B', displayText: 'Buenos Aires' },
		{ value: 'AR-K', displayText: 'Catamarca' },
		{ value: 'AR-H', displayText: 'Chaco' },
		{ value: 'AR-U', displayText: 'Chubut' },
		{ value: 'AR-X', displayText: 'Córdoba' },
		{ value: 'AR-W', displayText: 'Corrientes' },
		{ value: 'AR-E', displayText: 'Entre Ríos' },
		{ value: 'AR-P', displayText: 'Formosa' },
		{ value: 'AR-Y', displayText: 'Jujuy' },
		{ value: 'AR-L', displayText: 'La Pampa' },
		{ value: 'AR-F', displayText: 'La Rioja' },
		{ value: 'AR-M', displayText: 'Mendoza' },
		{ value: 'AR-N', displayText: 'Misiones' },
		{ value: 'AR-Q', displayText: 'Neuquén' },
		{ value: 'AR-R', displayText: 'Río Negro' },
		{ value: 'AR-A', displayText: 'Salta' },
		{ value: 'AR-J', displayText: 'San Juan' },
		{ value: 'AR-D', displayText: 'San Luis' },
		{ value: 'AR-Z', displayText: 'Santa Cruz' },
		{ value: 'AR-S', displayText: 'Santa Fe' },
		{ value: 'AR-G', displayText: 'Santiago del Estero' },
		{ value: 'AR-V', displayText: 'Tierra del Fuego' },
		{ value: 'AR-T', displayText: 'Tucumán' },
	],
	BR: [
		{ value: 'BR-DF', displayText: 'Distrito Federal' },
		{ value: 'BR-AC', displayText: 'Acre' },
		{ value: 'BR-AL', displayText: 'Alagoas' },
		{ value: 'BR-AP', displayText: 'Amapá' },
		{ value: 'BR-AM', displayText: 'Amazonas' },
		{ value: 'BR-BA', displayText: 'Bahia' },
		{ value: 'BR-CE', displayText: 'Ceará' },
		{ value: 'BR-ES', displayText: 'Espírito Santo' },
		{ value: 'BR-GO', displayText: 'Goiás' },
		{ value: 'BR-MA', displayText: 'Maranhão' },
		{ value: 'BR-MT', displayText: 'Mato Grosso' },
		{ value: 'BR-MS', displayText: 'Mato Grosso do Sul' },
		{ value: 'BR-MG', displayText: 'Minas Gerais' },
		{ value: 'BR-PA', displayText: 'Pará' },
		{ value: 'BR-PB', displayText: 'Paraíba' },
		{ value: 'BR-PR', displayText: 'Paraná' },
		{ value: 'BR-PE', displayText: 'Pernambuco' },
		{ value: 'BR-PI', displayText: 'Piauí' },
		{ value: 'BR-RJ', displayText: 'Rio de Janeiro' },
		{ value: 'BR-RN', displayText: 'Rio Grande do Norte' },
		{ value: 'BR-RS', displayText: 'Rio Grande do Sul' },
		{ value: 'BR-RO', displayText: 'Rondônia' },
		{ value: 'BR-RR', displayText: 'Roraima' },
		{ value: 'BR-SC', displayText: 'Santa Catarina' },
		{ value: 'BR-SP', displayText: 'São Paulo' },
		{ value: 'BR-SE', displayText: 'Sergipe' },
		{ value: 'BR-TO', displayText: 'Tocantins' },
	],
	MX: [
		{ value: 'MX-DIF', displayText: 'Distrito Federal' },
		{ value: 'MX-AGU', displayText: 'Aguascalientes' },
		{ value: 'MX-BCN', displayText: 'Baja California' },
		{ value: 'MX-BCS', displayText: 'Baja California Sur' },
		{ value: 'MX-CAM', displayText: 'Campeche' },
		{ value: 'MX-COA', displayText: 'Coahuila' },
		{ value: 'MX-COL', displayText: 'Colima' },
		{ value: 'MX-CHP', displayText: 'Chiapas' },
		{ value: 'MX-CHH', displayText: 'Chihuahua' },
		{ value: 'MX-DUR', displayText: 'Durango' },
		{ value: 'MX-GUA', displayText: 'Guanajuato' },
		{ value: 'MX-GRO', displayText: 'Guerrero' },
		{ value: 'MX-HID', displayText: 'Hidalgo' },
		{ value: 'MX-JAL', displayText: 'Jalisco' },
		{ value: 'MX-MEX', displayText: 'México' },
		{ value: 'MX-MIC', displayText: 'Michoacán' },
		{ value: 'MX-MOR', displayText: 'Morelos' },
		{ value: 'MX-NAY', displayText: 'Nayarit' },
		{ value: 'MX-NLE', displayText: 'Nuevo León' },
		{ value: 'MX-OAX', displayText: 'Oaxaca' },
		{ value: 'MX-PUE', displayText: 'Puebla' },
		{ value: 'MX-QUE', displayText: 'Querétaro' },
		{ value: 'MX-ROO', displayText: 'Quintana Roo' },
		{ value: 'MX-SLP', displayText: 'San Luis Potosí' },
		{ value: 'MX-SIN', displayText: 'Sinaloa' },
		{ value: 'MX-SON', displayText: 'Sonora' },
		{ value: 'MX-TAB', displayText: 'Tabasco' },
		{ value: 'MX-TAM', displayText: 'Tamaulipas' },
		{ value: 'MX-TLA', displayText: 'Tlaxcala' },
		{ value: 'MX-VER', displayText: 'Veracruz' },
		{ value: 'MX-YUC', displayText: 'Yucatán' },
		{ value: 'MX-ZAC', displayText: 'Zacatecas' },
	],
	CA: [
		{ value: 'CA-AB', displayText: 'Alberta' },
		{ value: 'CA-BC', displayText: 'British Columbia' },
		{ value: 'CA-MB', displayText: 'Manitoba' },
		{ value: 'CA-NB', displayText: 'New Brunswick' },
		{ value: 'CA-NL', displayText: 'Newfoundland and Labrador' },
		{ value: 'CA-NS', displayText: 'Nova Scotia' },
		{ value: 'CA-NT', displayText: 'Northwest Territories' },
		{ value: 'CA-NU', displayText: 'Nunavut' },
		{ value: 'CA-ON', displayText: 'Ontario' },
		{ value: 'CA-PE', displayText: 'Prince Edward Island' },
		{ value: 'CA-QC', displayText: 'Quebec' },
		{ value: 'CA-SK', displayText: 'Saskatchewan' },
		{ value: 'CA-YT', displayText: 'Yukon' },
	],
};

/** Returns all states for a given country code */
export function getStatesForCountry(countryCode: unknown): SelectableItem[] {
	const states = STATES_BY_COUNTRY[String(countryCode ?? '')] ?? [];
	return [...states]; // return new array reference
}

/** Returns only state values (codes) for a given country */
export function getStateValuesForCountry(countryCode: string): string[] {
	return (STATES_BY_COUNTRY[countryCode] ?? []).map((s) => String(s.value));
}

/** Checks if a country has any states */
export function hasStates(countryCode: string): boolean {
	return (STATES_BY_COUNTRY[countryCode]?.length ?? 0) > 0;
}
